// Centralised data-testids for testing
export const HOME = {
  emergentLink: 'home-emergent-link',
  heroCta: 'hero-cta-start',
  heroLogin: 'hero-cta-login',
  tradesGrid: 'home-trades-grid',
};

export const AUTH = {
  loginEmail: 'login-email-input',
  loginPassword: 'login-password-input',
  loginSubmit: 'login-submit-button',
  registerName: 'register-name-input',
  registerEmail: 'register-email-input',
  registerPassword: 'register-password-input',
  registerSubmit: 'register-submit-button',
  logoutBtn: 'logout-button',
  switchToRegister: 'auth-switch-register',
  switchToLogin: 'auth-switch-login',
};

export const NAV = {
  brand: 'nav-brand',
  trades: 'nav-trades',
  estimator: 'nav-estimator',
  assistant: 'nav-assistant',
  dashboard: 'nav-dashboard',
  jobs: 'nav-jobs',
  loginCta: 'nav-login-cta',
};

export const JOB = {
  newBtn: 'job-new-btn',
  createSubmit: 'job-create-submit',
  card: (id) => `job-card-${id}`,
  open: (id) => `job-open-${id}`,
  costAdd: 'job-cost-add',
  paymentAdd: 'job-payment-add',
  diaryAdd: 'job-diary-add',
  status: 'job-status-select',
  percent: 'job-percent-input',
  save: 'job-save-btn',
  delete: 'job-delete-btn',
};

export const CALC = {
  card: (slug) => `calc-card-${slug}`,
  input: (slug, key) => `calc-input-${slug}-${key}`,
  result: (slug) => `calc-result-${slug}`,
  resetBtn: (slug) => `calc-reset-${slug}`,
  toggle: (slug) => `calc-toggle-${slug}`,
};

export const EST = {
  name: 'est-name',
  trade: 'est-trade',
  itemDesc: (i) => `est-item-desc-${i}`,
  itemQty: (i) => `est-item-qty-${i}`,
  itemUnit: (i) => `est-item-unit-${i}`,
  itemRm: (i) => `est-item-remove-${i}`,
  addItem: 'est-add-item',
  labourHours: 'est-labour-hours',
  labourRate: 'est-labour-rate',
  materials: 'est-materials',
  vat: 'est-vat',
  margin: 'est-margin',
  notes: 'est-notes',
  save: 'est-save',
  exportPdf: 'est-export-pdf',
  total: 'est-total-display',
};

export const AI = {
  input: 'ai-chat-input',
  send: 'ai-chat-send',
  log: 'ai-chat-log',
};

export const DASH = {
  newProject: 'dash-new-project',
  projectCard: (id) => `dash-project-${id}`,
  delete: (id) => `dash-delete-${id}`,
};
